import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container animated fadeIn"
}
const _hoisted_2 = { class: "row mt-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "far fa-arrow-alt-circle-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "far fa-arrow-alt-circle-left" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "far fa-arrow-alt-circle-left" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "far fa-arrow-alt-circle-left" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_11 = { class: "col text-left font-weight-bold text-secondary" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_13 = { class: "rounded shadow p-3 mx-0" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h4", null, "Customer", -1)
const _hoisted_17 = { class: "table text-left" }
const _hoisted_18 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Id", -1)
const _hoisted_19 = { class: "table-list-value" }
const _hoisted_20 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Email", -1)
const _hoisted_21 = { class: "table-list-value" }
const _hoisted_22 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Full name", -1)
const _hoisted_23 = { class: "table-list-value" }
const _hoisted_24 = { class: "col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h4", null, "Pair", -1)
const _hoisted_26 = { class: "table text-left" }
const _hoisted_27 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Base currency", -1)
const _hoisted_28 = { class: "table-list-value" }
const _hoisted_29 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Quote currency", -1)
const _hoisted_30 = { class: "table-list-value" }
const _hoisted_31 = /*#__PURE__*/_createVNode("h4", null, "Order details", -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_34 = { class: "table text-left" }
const _hoisted_35 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Order ID", -1)
const _hoisted_36 = { class: "table-list-value" }
const _hoisted_37 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Order UUID", -1)
const _hoisted_38 = { class: "table-list-value font-weight-light font-italic" }
const _hoisted_39 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Side", -1)
const _hoisted_40 = { class: "table-list-value" }
const _hoisted_41 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_42 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Automatic execution", -1)
const _hoisted_44 = {
  key: 0,
  class: "table-list-value"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "badge badge-Light" }, "TRUE", -1)
const _hoisted_46 = {
  key: 1,
  class: "table-list-value"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-dark" }, "FALSE", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Status", -1)
const _hoisted_49 = {
  key: 0,
  class: "table-list-value"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-success" }, "Filled", -1)
const _hoisted_51 = {
  key: 1,
  class: "table-list-value"
}
const _hoisted_52 = {
  key: 0,
  class: "badge badge-pill badge-warning"
}
const _hoisted_53 = {
  key: 1,
  class: "badge badge-pill badge-success"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-success ml-2",
  style: {"font-size":"12px","padding":"1px 6px"}
}, [
  /*#__PURE__*/_createTextVNode(" Create filling order "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-exchange-alt" })
], -1)
const _hoisted_55 = {
  key: 2,
  class: "table-list-value"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-danger" }, "Pending", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-success ml-2",
  style: {"font-size":"12px","padding":"1px 6px"}
}, [
  /*#__PURE__*/_createTextVNode(" Create filling order "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-exchange-alt" })
], -1)
const _hoisted_58 = {
  key: 3,
  class: "table-list-value"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-danger" }, "Reversed", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Created at", -1)
const _hoisted_61 = { class: "table-list-value" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Last modified at", -1)
const _hoisted_64 = { class: "table-list-value" }
const _hoisted_65 = { class: "col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_66 = { class: "table text-left" }
const _hoisted_67 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Amount", -1)
const _hoisted_68 = { class: "table-list-value" }
const _hoisted_69 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Unit Price", -1)
const _hoisted_70 = { class: "table-list-value" }
const _hoisted_71 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Final Price", -1)
const _hoisted_72 = { class: "table-list-value" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Base Currency Revenue", -1)
const _hoisted_75 = {
  class: "table-list-value",
  style: {"font-weight":"600"}
}
const _hoisted_76 = { key: 1 }
const _hoisted_77 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Quote Currency Revenue", -1)
const _hoisted_78 = {
  class: "table-list-value",
  style: {"font-weight":"600"}
}
const _hoisted_79 = { key: 2 }
const _hoisted_80 = /*#__PURE__*/_createVNode("td", { class: "table-list-header text-danger" }, "Danger Zone", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-reply",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Reverse Order ")
const _hoisted_83 = { key: 3 }
const _hoisted_84 = /*#__PURE__*/_createVNode("td", { class: "table-list-header text-danger" }, "reversal of order ", -1)
const _hoisted_85 = {
  class: "table-list-value",
  style: {"font-weight":"600"}
}
const _hoisted_86 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("title", null, "Details"),
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
  })
], -1)
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-12 mb-3" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" This action cannot be undone. Please type ")
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" to confirm. ")
const _hoisted_91 = { class: "col-12" }
const _hoisted_92 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createTextVNode(" This action only can be done in orders with status: "),
    /*#__PURE__*/_createVNode("i", null, "Pending")
  ])
], -1)
const _hoisted_93 = { class: "col-12 text-right mt-3" }
const _hoisted_94 = {
  key: 0,
  class: "row"
}
const _hoisted_95 = { class: "col-12" }
const _hoisted_96 = /*#__PURE__*/_createVNode("h5", null, " Summary ", -1)
const _hoisted_97 = { class: "table table-sm" }
const _hoisted_98 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Provider"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Settlement Datetime"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      class: "text-right"
    }, "Unit Cost"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      class: "text-right"
    }, "Amount"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      class: "text-right"
    }, "Total Cost")
  ])
], -1)
const _hoisted_99 = { key: 0 }
const _hoisted_100 = /*#__PURE__*/_createVNode("th", {
  scope: "row",
  colspan: "6"
}, [
  /*#__PURE__*/_createVNode("small", null, " Looks like you don't have any filing orders yet. ")
], -1)
const _hoisted_101 = { class: "text-right" }
const _hoisted_102 = { class: "text-right" }
const _hoisted_103 = { class: "text-right" }
const _hoisted_104 = /*#__PURE__*/_createVNode("td", {
  class: "text-right",
  colspan: "4"
}, null, -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createVNode("b", null, " Total ")
], -1)
const _hoisted_106 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_ctx.getSelectedOrder)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (
          _ctx.$isAdmin &&
            _ctx.$route.name ===
              'on-behalf-of.account.statement.order.history.detail'
        )
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'on-behalf-of.home', query: { tab: 'order-history' } }
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (
          _ctx.$isAdmin &&
            _ctx.$route.name === 'on-behalf-of.account.statement.order.detail'
        )
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: {
          name: 'on-behalf-of.account.statement.report'
        }
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (
          !_ctx.$isAdmin && _ctx.$route.name === 'account.statement.order.history.detail'
        )
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: { name: 'Home', query: { tab: 'order-history' } }
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.$isAdmin && _ctx.$route.name === 'account.statement.order.detail')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                to: { name: 'account.statement.report' }
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, " Order detail #" + _toDisplayString(_ctx.getSelectedOrder.id), 1)
        ]),
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("table", _hoisted_17, [
                _createVNode("tr", null, [
                  _hoisted_18,
                  _createVNode("td", _hoisted_19, _toDisplayString(_ctx.getSelectedOrder.customer.id), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_20,
                  _createVNode("td", _hoisted_21, _toDisplayString(_ctx.hideEmail(_ctx.getSelectedOrder.customer.email)), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_22,
                  _createVNode("td", _hoisted_23, _toDisplayString(_ctx.getSelectedOrder.customer.firstName) + " " + _toDisplayString(_ctx.getSelectedOrder.customer.lastName), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("table", _hoisted_26, [
                _createVNode("tr", null, [
                  _hoisted_27,
                  _createVNode("td", _hoisted_28, [
                    _createTextVNode(_toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.id) + " " + _toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.description) + " ", 1),
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.getSelectedOrder.pair.baseCurrency.id,
                      reverse: true,
                      width: '20',
                      height: '20',
                      key: _ctx.getSelectedOrder.pair.baseCurrency.id
                    }, null, 8, ["cryptoCurrency"])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_29,
                  _createVNode("td", _hoisted_30, [
                    _createTextVNode(_toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.id) + " " + _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.description) + " ", 1),
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType == 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                      localCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType != 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                      width: '20',
                      height: '20',
                      key: _ctx.getSelectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_31,
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _createVNode("table", _hoisted_34, [
                _createVNode("tr", null, [
                  _hoisted_35,
                  _createVNode("td", _hoisted_36, "#" + _toDisplayString(_ctx.getSelectedOrder.id), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_37,
                  _createVNode("td", _hoisted_38, _toDisplayString(_ctx.getSelectedOrder.uuid), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_39,
                  _createVNode("td", _hoisted_40, [
                    (_ctx.getSelectedOrder.side == 1)
                      ? (_openBlock(), _createBlock("span", _hoisted_41, " BUY "))
                      : (_openBlock(), _createBlock("span", _hoisted_42, " SELL "))
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_43,
                  (_ctx.getSelectedOrder.automaticExecution == true)
                    ? (_openBlock(), _createBlock("td", _hoisted_44, [
                        _hoisted_45
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_46, [
                        _hoisted_47
                      ]))
                ]),
                _createVNode("tr", null, [
                  _hoisted_48,
                  (_ctx.getSelectedOrder.status == 0)
                    ? (_openBlock(), _createBlock("td", _hoisted_49, [
                        _hoisted_50
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getSelectedOrder.status == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_51, [
                        (_ctx.$isAdmin)
                          ? (_openBlock(), _createBlock("span", _hoisted_52, " Partially filled "))
                          : (_openBlock(), _createBlock("span", _hoisted_53, " Filled ")),
                        (_ctx.$isAdmin)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 2,
                              to: {
                    name: 'on-behalf-of.home.edit-manual.order',
                    params: { orderId: _ctx.getSelectedOrder.uuid }
                  }
                            }, {
                              default: _withCtx(() => [
                                _hoisted_54
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getSelectedOrder.status == 2)
                    ? (_openBlock(), _createBlock("td", _hoisted_55, [
                        _hoisted_56,
                        (_ctx.$isAdmin)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: {
                    name: 'on-behalf-of.home.edit-manual.order',
                    params: { orderId: _ctx.getSelectedOrder.uuid }
                  }
                            }, {
                              default: _withCtx(() => [
                                _hoisted_57
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getSelectedOrder.status == 3)
                    ? (_openBlock(), _createBlock("td", _hoisted_58, [
                        _hoisted_59
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("tr", null, [
                  _hoisted_60,
                  _createVNode("td", _hoisted_61, _toDisplayString(_ctx.formatDate(_ctx.getSelectedOrder.createdAt, 'YYYY-MM-DD HH:mm:ss')), 1)
                ]),
                (_ctx.formatDate(_ctx.getSelectedOrder.lastModifiedAt) && _ctx.$isAdmin)
                  ? (_openBlock(), _createBlock("tr", _hoisted_62, [
                      _hoisted_63,
                      _createVNode("td", _hoisted_64, _toDisplayString(_ctx.formatDate(
                    _ctx.getSelectedOrder.lastModifiedAt,
                    'YYYY-MM-DD HH:mm:ss'
                  )), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_65, [
              _createVNode("table", _hoisted_66, [
                _createVNode("tr", null, [
                  _hoisted_67,
                  _createVNode("td", _hoisted_68, [
                    _createTextVNode(_toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.id) + " " + _toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(_ctx.getSelectedOrder.amount)
                    : _ctx.formatZeros(
                        _ctx.getSelectedOrder.amount,
                        _ctx.getSelectedOrder.pair.baseCurrency.exact
                      )) + "  ", 1),
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.getSelectedOrder.pair.baseCurrency.id,
                      width: '20',
                      height: '20',
                      key: _ctx.getSelectedOrder.pair.baseCurrency.id
                    }, null, 8, ["cryptoCurrency"])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_69,
                  _createVNode("td", _hoisted_70, [
                    _createTextVNode(_toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.id) + " " + _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(_ctx.getSelectedOrder.unitPrice)
                    : _ctx.formatZeros(
                        _ctx.getSelectedOrder.unitPrice,
                        _ctx.getSelectedOrder.pair.quoteCurrency.exact
                      )) + "  ", 1),
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType == 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                      localCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType != 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                      width: '20',
                      height: '20',
                      key: _ctx.getSelectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_71,
                  _createVNode("td", _hoisted_72, [
                    _createTextVNode(_toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.id) + " " + _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(_ctx.getSelectedOrder.finalPrice)
                    : _ctx.formatZeros(
                        _ctx.getSelectedOrder.finalPrice,
                        _ctx.getSelectedOrder.pair.quoteCurrency.exact
                      )) + "  ", 1),
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType == 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                      localCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType != 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                      width: '20',
                      height: '20',
                      key: _ctx.getSelectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"])
                  ])
                ]),
                (_ctx.$isAdmin)
                  ? (_openBlock(), _createBlock("tr", _hoisted_73, [
                      _hoisted_74,
                      _createVNode("td", _hoisted_75, [
                        _createTextVNode(_toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.id) + "  " + _toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(_ctx.getSelectedOrder.baseCurrencyRevenue)
                    : _ctx.formatZeros(
                        _ctx.getSelectedOrder.baseCurrencyRevenue,
                        _ctx.getSelectedOrder.pair.baseCurrency.exact
                      )) + "  ", 1),
                        _createVNode(_component_icons_currency, {
                          cryptoCurrency: _ctx.getSelectedOrder.pair.baseCurrency.id,
                          width: '20',
                          height: '20',
                          key: _ctx.getSelectedOrder.pair.baseCurrency.id
                        }, null, 8, ["cryptoCurrency"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$isAdmin)
                  ? (_openBlock(), _createBlock("tr", _hoisted_76, [
                      _hoisted_77,
                      _createVNode("td", _hoisted_78, [
                        _createTextVNode(_toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.id) + "  " + _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(_ctx.getSelectedOrder.quoteCurrencyRevenue)
                    : _ctx.formatZeros(
                        _ctx.getSelectedOrder.quoteCurrencyRevenue,
                        _ctx.getSelectedOrder.pair.quoteCurrency.exact
                      )) + "  ", 1),
                        _createVNode(_component_icons_currency, {
                          cryptoCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType == 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                          localCurrency: 
                    _ctx.getSelectedOrder.pair.quoteCurrency.currencyType != 0
                      ? _ctx.getSelectedOrder.pair.quoteCurrency.id
                      : null
                  ,
                          width: '20',
                          height: '20',
                          key: _ctx.getSelectedOrder.pair.quoteCurrency.id
                        }, null, 8, ["cryptoCurrency", "localCurrency"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$isAdmin && !_ctx.getSelectedOrder.automaticExecution && _ctx.getSelectedOrder.status == 2)
                  ? (_openBlock(), _createBlock("tr", _hoisted_79, [
                      _hoisted_80,
                      _createVNode("td", null, [
                        _createVNode("button", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModalReverse && _ctx.openModalReverse(...args))),
                          class: "btn btn-danger btn-block"
                        }, [
                          _hoisted_81,
                          _hoisted_82
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$isAdmin && _ctx.getSelectedOrder.reversedOrderId)
                  ? (_openBlock(), _createBlock("tr", _hoisted_83, [
                      _hoisted_84,
                      _createVNode("td", _hoisted_85, [
                        _createVNode(_component_router_link, {
                          onClick: _ctx.updateOder,
                          to: {
                    name:'on-behalf-of.account.statement.order.history.detail',
                    params: { id: _ctx.getSelectedOrder.reversedOrderUuid },
                  }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_86
                          ]),
                          _: 1
                        }, 8, ["onClick", "to"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.getSelectedOrder.reversedOrderId), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Dialog, {
                header: "Are you absolutely sure?",
                visible: _ctx.showReverseModal,
                "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showReverseModal = $event)),
                breakpoints: { '960px': '75vw', '640px': '90vw' },
                style: { width: '40vw' },
                modal: true,
                onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reverseInputCode = ''))
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_87, [
                    _createVNode("div", _hoisted_88, [
                      _hoisted_89,
                      _createVNode("b", null, _toDisplayString(_ctx.reverseConfirmationCode), 1),
                      _hoisted_90
                    ]),
                    _createVNode("div", _hoisted_91, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.reverseInputCode = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.reverseInputCode]
                      ])
                    ]),
                    _hoisted_92,
                    _createVNode("div", _hoisted_93, [
                      _createVNode("button", {
                        class: "btn btn-sm btn-danger",
                        disabled: !_ctx.reverseInputCode || !_ctx.reverseConfirmationCode,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmReverseOrder && _ctx.confirmReverseOrder(...args)))
                      }, " Confirm ", 8, ["disabled"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ]),
          (_ctx.$isAdmin)
            ? (_openBlock(), _createBlock("div", _hoisted_94, [
                _createVNode("div", _hoisted_95, [
                  _hoisted_96,
                  _createVNode("table", _hoisted_97, [
                    _hoisted_98,
                    _createVNode("tbody", null, [
                      (_ctx.getSelectedOrder?.providerOrders.length === 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_99, [
                            _hoisted_100
                          ]))
                        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.getSelectedOrder.providerOrders, (filling, index) => {
                            return (_openBlock(), _createBlock("tr", {
                              key: filling.id
                            }, [
                              _createVNode("th", null, _toDisplayString(index + 1), 1),
                              _createVNode("td", null, [
                                _createVNode("b", null, _toDisplayString(filling.provider.name), 1)
                              ]),
                              _createVNode("td", null, _toDisplayString(_ctx.formatDate(filling.settlementDatetime)), 1),
                              _createVNode("td", _hoisted_101, _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.id) + "  " + _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(filling.unitCost)
                      : _ctx.formatZeros(
                          filling.unitCost,
                          _ctx.getSelectedOrder.pair.quoteCurrency.exact
                        )), 1),
                              _createVNode("td", _hoisted_102, _toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.id) + "  " + _toDisplayString(_ctx.getSelectedOrder.pair.baseCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(filling.amount)
                      : _ctx.formatZeros(
                          filling.amount,
                          _ctx.getSelectedOrder.pair.baseCurrency.exact
                        )), 1),
                              _createVNode("td", _hoisted_103, _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.id) + "  " + _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(filling.totalCost)
                      : _ctx.formatZeros(
                          filling.totalCost,
                          _ctx.getSelectedOrder.pair.quoteCurrency.exact
                        )), 1)
                            ]))
                          }), 128))
                    ]),
                    _createVNode("tfoot", null, [
                      _createVNode("tr", null, [
                        _hoisted_104,
                        _hoisted_105,
                        _createVNode("td", _hoisted_106, [
                          _createVNode("b", null, _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.id) + "  " + _toDisplayString(_ctx.getSelectedOrder.pair.quoteCurrency.currencyType === 1
                        ? '$ ' + _ctx.formatPrice(_ctx.calculateTotal)
                        : _ctx.formatZeros(
                            _ctx.calculateTotal,
                            _ctx.getSelectedOrder.pair.quoteCurrency.exact
                          )), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}